import { AuthCustomErrorMessage } from '$provider/constants/AuthCustomErrorMessage';
import ErrorStatus from '$shared/constants/ErrorStatus';
import UIErrorMessage from '$shared/constants/UIErrorMessage';
import { ErrorMessage } from '$shared/models/ErrorMessage';
import type { ErrorStatusMapping } from '.';

export class AuthError {
  public passwordAuth(): ErrorStatusMapping {
    return {
      [ErrorStatus.BadRequest]: ErrorMessage.create(UIErrorMessage.FailedToIdentifyReqOrg),
      [ErrorStatus.UnAuthourized]: ErrorMessage.create(UIErrorMessage.InvalidCredential),
      [ErrorStatus.Forbidden]: ErrorMessage.create(UIErrorMessage.FailedToAuthenticate),
      [ErrorStatus.Conflict]: ErrorMessage.create(UIErrorMessage.PasswordExpired)
    };
  }

  public changePassword(): ErrorStatusMapping {
    return {
      [ErrorStatus.BadRequest]: ErrorMessage.create(
        UIErrorMessage.FailedToIdentifyReqOrg,
        false,
        false,
        [],
        [],
        AuthCustomErrorMessage
      ),
      [ErrorStatus.Forbidden]: ErrorMessage.create(UIErrorMessage.ProvidedIncorrectCredential),
      [ErrorStatus.Conflict]: ErrorMessage.create(UIErrorMessage.PasswordExpired)
    };
  }

  public resetPassword(): ErrorStatusMapping {
    return {
      [ErrorStatus.BadRequest]: ErrorMessage.create(
        UIErrorMessage.FailedToResetPasswordWithTryAgain,
        false,
        false,
        [],
        [],
        AuthCustomErrorMessage
      ),
      [ErrorStatus.NotFound]: ErrorMessage.create(UIErrorMessage.FailedToResetPasswordWithDetail)
    };
  }

  public forgotPassword(): ErrorStatusMapping {
    return {
      [ErrorStatus.BadRequest]: ErrorMessage.create(UIErrorMessage.FailedToResetPassword)
    };
  }

  public googleAuth(): ErrorStatusMapping {
    return {
      [ErrorStatus.BadRequest]: ErrorMessage.create(UIErrorMessage.FailedToAuthenticate),
      [ErrorStatus.UnAuthourized]: ErrorMessage.create(UIErrorMessage.FailedToAuthoriseByGoogle),
      [ErrorStatus.Forbidden]: ErrorMessage.create(UIErrorMessage.FailedToAuthenticate)
    };
  }

  public oAuth(): ErrorStatusMapping {
    return {
      [ErrorStatus.BadRequest]: ErrorMessage.create(UIErrorMessage.FailedToAuthenticate),
      [ErrorStatus.UnAuthourized]: ErrorMessage.create(UIErrorMessage.FailedToAuthoriseBySso),
      [ErrorStatus.Forbidden]: ErrorMessage.create(UIErrorMessage.FailedToAuthenticate)
    };
  }

  public oAuthConfig(): ErrorStatusMapping {
    return {
      [ErrorStatus.NotFound]: ErrorMessage.create(UIErrorMessage.NoOAuthConfig, false)
    };
  }

  public invalidateToken(): ErrorStatusMapping {
    return {
      [ErrorStatus.BadRequest]: ErrorMessage.create(
        UIErrorMessage.CouldNotLogoutCurrentSession,
        true
      ),
      [ErrorStatus.NotFound]: ErrorMessage.create(UIErrorMessage.CouldNotLogoutCurrentSession, true)
    };
  }

  public listTokens(): ErrorStatusMapping {
    return {
      [ErrorStatus.BadRequest]: ErrorMessage.create(UIErrorMessage.FailedToLoadLoggedDevices, true)
    };
  }

  public credListOrg(): ErrorStatusMapping {
    return {
      [ErrorStatus.BadRequest]: ErrorMessage.create(UIErrorMessage.FailedToGetCredGrants, true),
      [ErrorStatus.NotFound]: ErrorMessage.create(UIErrorMessage.FailedToGetCredGrants)
    };
  }

  public credUserList(): ErrorStatusMapping {
    return {
      [ErrorStatus.BadRequest]: ErrorMessage.create(UIErrorMessage.FailedToGetCredUsers, true),
      [ErrorStatus.NotFound]: ErrorMessage.create(UIErrorMessage.FailedToGetCredUsers)
    };
  }

  public userList(): ErrorStatusMapping {
    return {
      [ErrorStatus.BadRequest]: ErrorMessage.create(UIErrorMessage.FailedToLoadOrgUsers, true),
      [ErrorStatus.NotFound]: ErrorMessage.create(UIErrorMessage.FailedToLoadOrgUsers)
    };
  }
}

export const authError = new AuthError();
